const FundingBar = () => {
  const data = [
    {
      month: 2025,
      values: [
        { value: 180, category: "Total Land Use Reviews", month: 2025 },
      ],
    },
    {
      month: 2024,
      values: [
        { value: 176, category: "Total Land Use Reviews", month: 2024 },
      ],
    },
    {
      month: 2023, 
      values: [
        { value: 227, category: "Total Land Use Reviews", month: 2023 },
      ],
    },
    {
      month: 2022,
      values: [
        { value: 327, category: "Total Land Use Reviews", month: 2022 },
      ],
    },
    {
      month: 2021,
      values: [
        { value: 314, category: "Total Land Use Reviews", month: 2021 },
      ],
    },
    {
      month: 2020,
      values: [
        { value: 223, category: "Total Land Use Reviews", month: 2020 },
      ],
    },
    {
      month: 2019,
      values: [
        { value: 193, category: "Total Land Use Reviews", month: 2019 },
      ],
    },
    {
      month: 2018,
      values: [
        { value: 216, category: "Total Land Use Reviews", month: 2018 },
      ],
    },
    {
      month: 2017,
      values: [
        { value: 198, category: "Total Land Use Reviews", month: 2017 },
      ],
    },
    {
      month: 2016,
      values: [
        { value: 265, category: "Total Land Use Reviews", month: 2016 },
      ],
    },
    {
      month: 2015,
      values: [
        { value: 198, category: "Total Land Use Reviews", month: 2015 },
      ],
    },
    {
      month: 2014,
      values: [
        { value: 154, category: "Total Land Use Reviews", month: 2014 },
      ],
    },
  ];

  let tooltipCard;

  const createTooltip = month => {
    if (month !== null || typeof month !== 'undefined') {
      const tooltipData = data.filter(d => d.month === month);

      if (document.querySelector('.tooltip-card-precip') !== null) {
        document.querySelector('.tooltip-card-precip').remove();
      }

      tooltipCard = d3.select('body').append('div').attr('class', 'tooltip-card tooltip-card-precip');

      let html = '';
      if (tooltipData.length > 0) {
        html = `<div class="ts-tooltip-title">${tooltipData[0].month}</div>`;
        tooltipData[0].values.forEach((d, i) => {
          const legendStyle = `background: ${colors[i]}`;
          html += `
            <div class="ts-tooltip-value-wrapper">
              <div class="ts-tooltip-legend" style="${legendStyle}"></div>
              <div class="ts-tooltip-value">${d.category}: ${d.value}</div>
            </div>`;
        });
      }

      tooltipCard.html(html);
      const tooltipWidth = Number(tooltipCard.style('width').slice(0, -2));
      const xPos = document.body.offsetWidth / event.pageX < 1.3 ? event.pageX - (tooltipWidth + 15) : event.pageX + 15;

      tooltipCard
          .style('opacity', 1)
          .style('left', `${xPos}px`)
          .style('top', `${event.pageY - 15}px`);
    }
  };

  const removeTooltip = () => {
    tooltipCard.style('opacity', 0);
  };

  d3.select('#precip-comparison-graph-section #graph svg').remove();
  const svg = d3.select('#precip-comparison-graph-section #graph').append('svg');
  const mobile = document.body.offsetWidth < 769;

  const colors = ['#5c6bc0'];

  let initWidth = d3.select('#precip-comparison-graph-section #graph').style('width');
  initWidth = parseInt(initWidth.substring(0, initWidth.length - 2));
  initWidth = mobile ? initWidth * 0.85 : initWidth * 0.95;
  const initHeight = initWidth * 0.45;

  const margin = { top: 15, right: 15, bottom: 25, left: 65 };
  const width = initWidth - margin.left - margin.right;
  const height = initHeight - margin.top - margin.bottom;

  svg.attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);

  const g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

  const x0 = d3.scaleBand().rangeRound([0, width]).paddingInner(0.1);
  const x1 = d3.scaleBand().padding(0.05);
  const y = d3.scaleLinear().rangeRound([height, 0]);

  x0.domain(data.map(d => d.month));
  x1.domain(['Total Land Use Reviews']).rangeRound([0, x0.bandwidth()]);
  y.domain([0, 400]);

  g.append('g')
      .style('font-size', '18px')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x0));

  const yAxisCenter = (height - margin.top - margin.bottom) / 2;

  g.append('g')
      .style('font-size', '18px')
      .attr('class', 'axis axis--y')
      .call(d3.axisLeft(y))
      .append('text')
      .attr('fill', '#000')
      // Position the text halfway down the axis
      .attr('transform', `rotate(-90) translate(${-yAxisCenter}, -50)`)
      .attr('text-anchor', 'middle') // Centers the text on its position
      .style('font-size', '24px')
      .text('Land Use');

  const slice = g
      .selectAll('.slice')
      .data(data)
      .enter()
      .append('g')
      .attr('class', 'g')
      .attr('transform', d => `translate(${x0(d.month)},0)`);

  slice
      .selectAll('rect')
      .data(d => d.values)
      .enter()
      .append('rect')
      .attr('width', x1.bandwidth())
      .attr('x', d => x1(d.category))
      .style('fill', '#333333')
      .style('fill', (d, i) => colors[i])
      .attr('y', d => y(d.value))
      .attr('height', d => height - y(d.value))
      .on('mouseover', function (d, i) {
        createTooltip(d.month);
      })
      .on('mouseout', function (d, i) {
        removeTooltip(removeTooltip);
      });
};
